import { Outlet, createFileRoute } from "@tanstack/react-router";

// Layout route only: suppliers/ has children (index = the registry list, $supplierId = the detail).
// Rendering the list page here shadowed every child, which is exactly the bug fixed for obligations
// on 2026-07-28 — the supplier profile matched the URL and went [active] in the nav while its
// component never mounted, so the whole page (PIN check, TCC, notes, business registry) was dead.
export const Route = createFileRoute("/(app)/dashboard/suppliers")({
  component: () => <Outlet />,
});
